"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ signUpInputForm, }) {
    const { watch, setValue, register } = signUpInputForm;
    const termsOfUseAgree = watch('terms_of_use_agree');
    const personalInfoAgree = watch('personal_info_agree');
    const marketingAgree = watch('marketing_agree');
    const isAgreedAll = termsOfUseAgree && personalInfoAgree && marketingAgree;
    const changeAllAgreements = () => {
        if (isAgreedAll) {
            setValue('terms_of_use_agree', false);
            setValue('personal_info_agree', false);
            setValue('marketing_agree', false);
        }
        else {
            setValue('terms_of_use_agree', true);
            setValue('personal_info_agree', true);
            setValue('marketing_agree', true);
        }
    };
    /** @desc FCL: FormControlLabel */
    const agreeFCLSxObj = {
        m: '1px 0 1px -3.5px',
        '.MuiCheckbox-root': { p: '6px' },
        '.MuiFormControlLabel-label': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            fontSize: '14px',
            color: 'rgba(0, 0, 0, 0.8)',
        },
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'grid', padding: '13px 16px', marginBottom: '82px' } }, { children: [(0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: {
                    m: '5px 0 5px -5px',
                    '.MuiCheckbox-root': { p: '4.5px' },
                    '.MuiFormControlLabel-label': { fontSize: '16px', fontWeight: 'bold' },
                }, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: isAgreedAll, onChange: changeAllAgreements, css: { svg: { width: '27px', height: '27px' } } }), label: t('전체동의') }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: agreeFCLSxObj, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, Object.assign({}, register('terms_of_use_agree'), { checked: termsOfUseAgree })), label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`[${t('필수')}] ${t('서비스 이용약관 동의')}`, (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ href: "/policy/", target: "_blank", rel: "noopener noreferrer", disableRipple: true }, { children: (0, jsx_runtime_1.jsx)(svgs_1.ChevronRightGraySvg, {}) }))] }) }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: agreeFCLSxObj, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, Object.assign({}, register('personal_info_agree'), { checked: personalInfoAgree })), label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`[${t('필수')}] ${t('개인정보 수집 및 이용 동의')}`, (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ href: "/privacy/", target: "_blank", rel: "noopener noreferrer", disableRipple: true }, { children: (0, jsx_runtime_1.jsx)(svgs_1.ChevronRightGraySvg, {}) }))] }) }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: agreeFCLSxObj, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, Object.assign({}, register('marketing_agree'), { checked: marketingAgree })), label: `[${t('H-선택')}] ${t('마케팅 정보 수신')}` })] })));
}
exports.default = default_1;
